var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranscriptRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.773,
    height: 21.233,
    viewBox: "0 0 31.773 21.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#666;stroke-width:0.4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.2 -85.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 86)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,86v20.833H31.373V86Zm29.534,19H1.838V87.838h27.7Z",
    transform: "translate(0 -86)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.286 96.998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.478,
    height: 1.935
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.537 96.998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.482,
    height: 1.935
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.702 100.707)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.317,
    height: 1.774
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.286 100.707)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.482,
    height: 1.774
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscriptRequest);
export default __webpack_public_path__ + "static/media/transcript-request.fe1554f8491c0ed7b2a46ef2fab6d12a.svg";
export { ForwardRef as ReactComponent };